import { FormButtonElement } from "@redotech/redo-model/signup-form";
import { memo } from "react";
import { BrandKitButton } from "../../brand-kit-button";
import { FormElementProps } from "./index";

export const FormButton = memo(function FormButton({
  form,
  element,
  brandKit,
  ...props
}: FormElementProps<FormButtonElement>) {
  return (
    <BrandKitButton
      brandKit={brandKit}
      hierarchy={element.hierarchy}
      onClick={() => {}}
      override={
        form.theme.overrides.buttons.enabled
          ? form.theme.overrides.buttons
          : undefined
      }
      pending={props.submitting}
      text={element.text}
      type="submit"
    />
  );
});
